import { engagementCardData } from '../components/engagement-section/card-data';
import { FEATURE_INTERESTS } from '../../setup/constants';
import { useSellerOnboardingJson } from '../../../hooks/use-seller-setting';

const progressiveDisclosureCards = {
  [FEATURE_INTERESTS.DISCOUNTED_RATES]: 1,
  [FEATURE_INTERESTS.CUSTOM_BRANDING]: 2,
  [FEATURE_INTERESTS.IMPORT_ORDERS]: 6,
  [FEATURE_INTERESTS.AUTOMATE_PROCESSES]: 8,
  [FEATURE_INTERESTS.INTERNATIONAL_SHIPPING]: 19,
  [FEATURE_INTERESTS.RETURNS]: 23,
};

const getFeaturesOfInterest = (features) => features.map((feature) => progressiveDisclosureCards[feature]);

const getCardsWithPrerequisitesMet = (cards) => cards.filter((card) => card.getShouldRender());

const getCardIdsWhenPrerequisitesAreMet = (cards) => cards.map((card) => card.id);

const prioritizeFeatureInterests = (featuresOfInterest, orderArray) => {
  const combinedArray = [...featuresOfInterest, ...orderArray];
  return [...new Set(combinedArray)];
};

const getOrderedCardsArray = (orderArray) => orderArray.map((orderId) => engagementCardData.find((obj) => obj.id === orderId));

/**
 * Custom hook to determine the order of engagement cards to be displayed in the user's feed.
 *
 * This hook takes into account the user's features of interest, reverses the first five cards
 * in the prioritized order, and filters out any cards that the user has chosen to hide and
 * cards that require admin privileges for users without admin role.
 * It returns an array of active cards limited to a maximum number of cards to display.
 * @param {number[]} orderArray - The default order of card IDs.
 * @returns {object[]} - An array of card objects in the order they should be displayed.
 */

export const useFeedCardOrder = () => {
  const { FEATURE_INTEREST } = useSellerOnboardingJson() || {};
  const featuresOfInterest = getFeaturesOfInterest(FEATURE_INTEREST?.featuresOfInterest || []);

  const cardsWithPrerequisitesMet = getCardsWithPrerequisitesMet(engagementCardData);
  const cardIds = getCardIdsWhenPrerequisitesAreMet(cardsWithPrerequisitesMet);
  const prioritizedOrder = prioritizeFeatureInterests(featuresOfInterest, cardIds);

  return getOrderedCardsArray(prioritizedOrder);
};
